module.exports = __webpack_public_path__ + "img/mineBackGround.8fcb1463.png";